import cn from 'classnames'
import { BiSolidInfoCircle } from 'react-icons/bi'

export default function BidMsrpButton({ lgLeft = false, inline = false }) {
  return (
    <div className={cn('group relative', !inline && 'h-[12px]')}>
      <button type="button" className="text-bidfta-blue-light pt-[3px]">
        <BiSolidInfoCircle viewBox={'2 2 20 20'} />
      </button>
      <div
        className={cn(
          `absolute top-2 left-1/2 transform -translate-x-1/2 -translate-y-full
        mt-1.5 px-1.5 py-1.5 text-white text-sm rounded-lg opacity-0 group-hover:opacity-100
        group-hover:scale-100 scale-0 transition-all duration-300`,
          lgLeft && 'lg:top-[200%] lg:-left-[150%]'
        )}
      >
        <div
          className={cn(
            'w-36 py-2 px-3 bg-bidfta-yellow',
            lgLeft && 'lg:absolute lg:right-1/2 lg:bottom-[15%]'
          )}
        >
          <p className="relative z-30 text-black">
            MSRP is a sample online retail price.
          </p>
        </div>
        <div className="relative w-6 h-6 transform rotate-45 bg-bidfta-yellow -translate-x-1/2 left-1/2 -top-4 z-20" />
      </div>
    </div>
  )
}